import React, { useState, useEffect } from 'react';
import { attributeUnitService } from '../../services';
import { DataTable } from '../../components';
import { useSideDialog, useModalDialog, useGlobalState, useMessage } from '../../hooks';
import { handleError, Role } from '../../helpers';

export const AttributeUnits = () => {
  const [attributeUnits, setAttributeUnits] = useState([]);
  const [loggedInUser, setLoggedInUser] = useGlobalState('loggedInUser');
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const clearSelectedItems = () => {
    setSelectedItems([]);
  };

  const { showMessage } = useMessage();
  const { showSideDialog, hideSideDialog, setSideDialog } = useSideDialog(clearSelectedItems);
  const { showModalDialog, hideModalDialog } = useModalDialog();

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    attributeUnitService
      .getAll()
      .then(res => {
        setAttributeUnits(res.attribute_units);
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        showMessage(err, 'error');
      });
  };

  const addAttributeUnit = async data => {
    const attributeUnits = { attribute_units: [data] };

    await attributeUnitService
      .create(attributeUnits)
      .then(res => {
        setSideDialog(prev => ({ ...prev, formErrors: {} }));
        fetchItems();
        showMessage(res.message);
      })
      .catch(err => {
        handleError({ err, showMessage, setSideDialog });
        throw err;
      });
  };

  const editAttributeUnit = async data => {
    const attributeUnits = { attribute_units: Array.isArray(data) ? data : [data] };

    await attributeUnitService
      .update(attributeUnits)
      .then(async res => {
        fetchItems();
        showMessage(res.message);
        clearSelectedItems();
        hideSideDialog();
      })
      .catch(err => {
        handleError({ err, showMessage, setSideDialog });
        throw err;
      });
  };

  const deleteAttributeUnit = async data => {
    await attributeUnitService
      .destroy({ attribute_units: data })
      .then(async res => {
        hideModalDialog();
        clearSelectedItems();
        fetchItems();
        showMessage(res.message);
      })
      .catch(err => {
        showMessage(err, 'error');
      });
  };

  const editable = loggedInUser && loggedInUser.user_role_name === Role.admin;

  return (
    <DataTable
      columns={[
        { id: 'attribute_unit_name', name: 'Name', className: 'bold' },
        { id: 'attribute_unit_code', name: 'Code' },
      ]}
      buttons={[
        {
          label: '+ Add',
          action: 'add',
          mainButton: true,
          onClick: items =>
            showSideDialog('addAttributeUnit', items || selectedItems, addAttributeUnit),
        },
        {
          label: 'Edit',
          action: 'edit',
          onClick: items =>
            showSideDialog('editAttributeUnit', items || selectedItems, editAttributeUnit),
        },
        {
          label: 'Delete',
          action: 'delete',
          onClick: items =>
            showModalDialog('deleteAttributeUnit', items || selectedItems, deleteAttributeUnit),
        },
      ]}
      data={attributeUnits}
      idColumn="attribute_unit_id"
      primaryColumn="attribute_unit_name"
      selectedItems={selectedItems}
      setSelectedItems={setSelectedItems}
      loading={loading}
      filterable={true}
      filterObjects={['attribute_unit_name', 'attribute_unit_code']}
    />
  );
};
